// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"fac04a33","769":"31fd7bfc"}[chunkId] + ".chunk.js";
};